import moment from 'moment';

export function getLiveClassStatus(liveClass, now = moment()) {
  const start = moment(liveClass['initial-date']);
  const end = moment(liveClass['end-date']);

  if (now.isBetween(start, end)) return 'ao-vivo';
  if (now.isBefore(start)) return 'agendada';
  return 'finalizada';
}
